






























































































import {Vue, Component, Prop} from 'vue-property-decorator/lib/vue-property-decorator';
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";

@Component({
    components: {CustomDatePicker},
})

export default class HoldDetails extends Vue {
    @Prop({required: true}) holdTicket!: HoldTicket;
    @Prop({required: true}) type!: String;

}
